var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pageTitle"},[_c('h1',{staticClass:"pageTitle__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.sub)?_c('div',{staticClass:"pageTitle__sub"},[_vm._v(_vm._s(_vm.sub)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }